//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
export default {
  name: 'KeyBoard',
  data() {
    return {
      licenseKB: '',
      keyType: 'province',
      "keyLicensePlate": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "delete", "select", "Z", "X", "C", "V", "B", "N", "M", "confirm"],//车牌字符
      "keyProvince": ["粤", "湘", "闽", "桂", "沪", "京", "苏", "浙", "川", "辽", "鲁", "渝", "云", "陕", "赣", "晋", "津", "皖", "鄂", "豫", "冀", "黑", "吉", "贵", "蒙", "琼", "甘", "新", "delete", "select", "藏", "青", "宁", "临","挂","学", "confirm"],//车牌省份
    };
  },
  computed: {
    ...mapGetters(['getShowKB', 'getLicenseKB']),
  },
  methods: {
    ...mapMutations(['hideKB', 'setLicenseKB']),
    clickKB(item) {
      this.licenseKB = this.getLicenseKB;
      this.licenseKB += item;
      this.licenseKB = this.licenseKB.substring(0, 10);
    },
    del() {
      this.licenseKB=this.getLicenseKB.substring(0, (this.getLicenseKB.length - 1));
      this.setLicenseKB(this.getLicenseKB.substring(0, (this.getLicenseKB.length - 1)));
      if(!this.licenseKB){
        this.$set(this,'keyType','province')
      }
    },
    switch2liscense(e){
      let targetEl = e.srcElement || e.target;
      if(targetEl.className.indexOf('kb-province') !== -1){
        this.keyType = 'license';
      }
    },
    doThis: function () {
        
    },
  },
  watch: {
    licenseKB(val) {
      this.setLicenseKB(val);
    },
    getShowKB(val){
      if(this.licenseKB){
        this.$set(this,'keyType','license')
      }else{
        this.$set(this,'keyType','province')
      }
    }
  },
  mounted() { 
  },
};
